import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { Link } from 'react-router-dom';
import moment from 'moment';

export default function TicketTable({ info }) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell>Ticket Number</TableCell>
            <TableCell align='right'>Type</TableCell>
            <TableCell align='right'>Created</TableCell>
            <TableCell align='right'>Priority</TableCell>
            <TableCell align='right'>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {info.map((row) => (
            <TableRow key={row.ticket_id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell scope='row' component={Link} to={`/my-tickets/details/${row.ticket_id}`}>
                {row.ticket_id}
              </TableCell>
              <TableCell align='right'>{row.subject}</TableCell>
              <TableCell align='right'>{moment(row.createdAt).format('DD-MM-YYYY')}</TableCell>
              <TableCell align='right'>{row.priority}</TableCell>
              <TableCell align='right'>{row.is_resolved ? 'Resolved' : 'Open'}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
